module.exports = __webpack_public_path__ + "static/universe-logo-668a092bcb775b75d261d1302574fdf4.svg";